<button nz-button nzType="text" nz-dropdown [nzDropdownMenu]="notificationMenu" [nzVisible]="visible"
        (nzVisibleChange)="onVisibleChange($event)" [nzOverlayClassName]="'notification-overlay'"
        class="notification-trigger" [attr.aria-label]="'NOTIFICATIONS.ARIA_LABEL' | translate">
  <nz-badge [nzCount]="unreadCount" [nzOverflowCount]="99"><span nz-icon nzType="bell" nzTheme="outline"></span>
  </nz-badge>
</button>
<nz-dropdown-menu #notificationMenu="nzDropdownMenu">
  <div #notificationPanel class="notification-panel" role="region" [attr.aria-label]="'NOTIFICATIONS.TITLE' | translate">
    <div class="notification-header"><strong>{{ 'NOTIFICATIONS.TITLE' | translate }}</strong>
      <button nz-button nzType="link" [disabled]="!unreadCount"
              (click)="markAllRead()">{{ 'NOTIFICATIONS.ACTIONS.MARK_ALL_READ' | translate }}
      </button>
    </div>
    <div class="notification-filters" role="group" [attr.aria-label]="'NOTIFICATIONS.FILTERS.READ_STATE' | translate">
      <button *ngFor="let state of readStates" nz-button nzSize="small"
              [nzType]="readState === state ? 'primary' : 'default'"
              (click)="selectReadState(state)">{{ ('NOTIFICATIONS.FILTERS.' + state.toUpperCase()) | translate }}
      </button>
    </div>
    <nz-spin [nzSpinning]="loading">
      <div *ngIf="error" class="notification-error"><span>{{ 'NOTIFICATIONS.ERROR.LOAD_FAILED' | translate }}</span>
        <button nz-button (click)="load()">{{ 'NOTIFICATIONS.ACTIONS.RETRY' | translate }}</button>
      </div>
      <nz-empty *ngIf="!loading && !error && !items.length" [nzNotFoundContent]="emptyKey() | translate"></nz-empty>
      <div *ngFor="let item of items" class="notification-item" [class.unread]="!item.readAt" role="button" tabindex="0"
           (click)="open(item)" (keydown.enter)="open(item)" (keydown.space)="$event.preventDefault(); open(item)"><span
        nz-icon [nzType]="icon(item)" [class]="'severity-' + item.severity"></span><span
        class="notification-copy"><strong>{{ title(item) }}</strong><span *ngIf="body(item)" #bodyEl
                                                                          [attr.data-notification-id]="item.id"
                                                                          class="notification-body"
                                                                          [class.notification-body--expanded]="isExpanded(item)">{{ body(item) }}</span><button
        *ngIf="body(item) && (isOverflowing(item) || isExpanded(item))" type="button" class="notification-expand-toggle"
        (click)="toggleBodyExpansion($event, item)"
        (keydown)="$event.stopPropagation()">{{ (isExpanded(item) ? 'NOTIFICATIONS.SHOW_LESS' : 'NOTIFICATIONS.SHOW_MORE') | translate }}</button><small>{{ relativeTime(item.createdAt) }}</small></span><span
        *ngIf="!item.readAt" class="unread-dot"></span></div>
      <button *ngIf="nextCursor" nz-button nzBlock
              (click)="load(nextCursor)">{{ 'NOTIFICATIONS.ACTIONS.LOAD_MORE' | translate }}
      </button>
    </nz-spin>
  </div>
</nz-dropdown-menu>
